import { Component, OnInit } from '@angular/core';
import { ShareDataService } from 'src/app/services/share-data.service';

@Component({
  selector: 'app-azure-step2',
  templateUrl: './azure-step2.component.html',
  styleUrls: ['./azure-step2.component.scss']
})
export class AzureStep2Component implements OnInit {

  toggleOptions: any = {
    Hardware: false,
    Software: false,
    Electricity: false,
    Virtualization: false,
    Data: false,
    Networking: false,
    Database: false,
    warehouse: false
  };

  hardwareCostAssumption: any;
  dataCentCostAssumption: any;
  electricityCostAssumption: any;
  SoftwareCostAssumption: any;
  dataWareHouseAssumption: any;
  storageAssumption: any;
  itlaborcosts: any;
  networkingAssumption: any;
  dbLicenseAssumption: any;

  data = {
    hardwareCostAssumption: [],
    softwareCostAssumption: [],
    electricityCostAssumption: [],
    HardwareMaintenanceCostPercentage: 20,
    K80Cost: 5000,
    M60Cost: 6000,
    Currency: '1',
    WindowsDatacentreLicenseCost: 769.375,
    WindowsStandardLicenseCost: 121.5,
    TotalSoftwareAssuranceCost: 8665.75,
    EnterpriseSoftwareAssurancecost: 1,
    StandardSoftwareAssurancecost: 1,
    PricePerKWHour: 1,
    NumberOfRackUnitsPerRack: 42,
    DataCenterUsefulLife: 1,
    ConstructionCost: 906,
    NetworkHwSwCostPercentage: 1,
    NetworkMaintenanceCostPercentage: 20,
    ServiceProviderCostPerGB: 0.20,
    TotalHardwareSoftwareCostOverYear: 21,
    PerTapeDriveCost: 4500,
    HourlyRate: 1,
    ITAdminHour: 46.51
  };

  selectedCurrencyId = '1';

  constructor(
    public shareDataService: ShareDataService
  ) {
    this.hardwareCostAssumption = this.shareDataService.setep2.hardwareCostAssumption;
    this.dataCentCostAssumption = this.shareDataService.setep2.dataCentCostAssumption;
    this.electricityCostAssumption = this.shareDataService.setep2.electricityCostAssumption;
    this.SoftwareCostAssumption = this.shareDataService.setep2.SoftwareCostAssumption;
    this.dataWareHouseAssumption = this.shareDataService.setep2.dataWareHouseAssumption;
    this.storageAssumption = this.shareDataService.setep2.storageAssumption;
    this.itlaborcosts = this.shareDataService.setep2.itlaborcosts;
    this.networkingAssumption = this.shareDataService.setep2.networkingAssumption;
    this.dbLicenseAssumption = this.shareDataService.setep2.dbLicenseAssumption;
  }

  ngOnInit(): void {
    window.scroll(0,0);
    // console.log(this.networkingAssumption);
  }

  onSTOToggleClick(data: string): void {
    this.toggleOptions[data] = !this.toggleOptions[data];
  }

  onToggleClick(data: string): void {
    this.toggleOptions[data] = !this.toggleOptions[data];
  }

  next(): any{
    this.shareDataService.setep2.Currency = this.selectedCurrencyId;
    this.data.TotalHardwareSoftwareCostOverYear = this.data.NetworkHwSwCostPercentage + this.data.NetworkMaintenanceCostPercentage;
    this.shareDataService.setep2 = this.data;
    this.shareDataService.setep2.hardwareCostAssumption = this.hardwareCostAssumption;
    this.shareDataService.setep2.dataCentCostAssumption = this.dataCentCostAssumption;
    this.shareDataService.setep2.electricityCostAssumption = this.electricityCostAssumption;
    this.shareDataService.setep2.SoftwareCostAssumption = this.SoftwareCostAssumption;
    this.shareDataService.setep2.dataWareHouseAssumption = this.dataWareHouseAssumption;
    this.shareDataService.setep2.storageAssumption = this.storageAssumption;
    this.shareDataService.setep2.itlaborcosts = this.itlaborcosts;
    this.shareDataService.setep2.networkingAssumption = this.networkingAssumption;
    this.shareDataService.setep2.dbLicenseAssumption = this.dbLicenseAssumption;
    this.shareDataService.step = 3;
  }

  back(): any{
    this.shareDataService.step = 1;
  }

}
